<template>
  <div class="dropdown" v-click-outside="closeDropdown">
    <button class="dropdown-toggle flex between align-center" @click="toggleDropdown">
      <span :class="{selected: this.hasSomethingSelected}">{{ selectedLabel }}</span>
      <span class="caret" :class="{ flip: isOpen }"></span>
    </button>
    <div v-if="isOpen" class="dropdown-menu-connector"></div>
    <div class="dropdown-menu scrollable-y" v-show="isOpen">
      <button
        class="dropdown-item"
        v-for="(option, index) in options"
        :key="index"
        @click="selectOption(option)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "Select an option",
    },
    modelValue: {
      type: [String, Number, null],
      default: null,
    },
  },
  computed: {
    // Determines what text to display inside the dropdown button
    selectedLabel() {
      const selected = this.options.find((option) => option.value === this.modelValue);
      return selected ? selected.label : this.placeholder;
    },
    hasSomethingSelected() {
      return this.modelValue !== null;
    }
  },
  methods: {
    // Toggles the dropdown open or closed
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    // Handles option selection and updates the model value
    selectOption(option) {
      this.$emit("update:modelValue", option.value);
      this.isOpen = false;
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  display: inline-block;
  width: 100%;
}

.dropdown-toggle {
  color: #fff;
  border-radius: 6.25rem;
  border: 1px solid rgba(132, 132, 132, 0.9);
  font-size: 1.125rem;
  font-weight: 500;
  width: 100%;
  padding: 10px 10px;
  background-color: #242424;
  cursor: pointer;
  outline: none;

  span:not(.caret){
    border-radius: 20px;
    display: block;
    width: calc(100% - 30px);
    text-align: start;
    padding: 0 10px;
  }

  span.selected {
    background-color: var(--primary);
  }
}

.dropdown-toggle:hover {
  border-color: rgba(132, 132, 132, 1);
}

.dropdown-menu-connector {
  position: absolute;
  height: 23px;
  background-color: #474747;
  margin-top: -15px;
  width: 100%;
  z-index: -1;
}

.dropdown-menu {
  position: absolute;
  width: 100%;
  background-color: rgb(71, 71, 71);
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  padding: 0.5rem;
  border-radius: 0 0 6px 6px;
  max-height: max(20rem, 50vh);
  overflow-y: auto;
  z-index: 2;
}

.dropdown-item {
  color: white;
  border-radius: 6.25rem;
  text-align: center;
  width: 100%;
  padding: 0.4rem;
  line-height: 1.4rem;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: var(--primary);
}

.caret {
  border: solid white;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  margin-left: 5px;
  transform: rotate(45deg);
  transition: transform 0.3s ease-in-out;
}

.caret.flip {
  transform: rotate(-135deg);
}
</style>